document.addEventListener("submit", function(e){

  const form = e.target.closest('form[action="/cart/add"]');
  if(!form) return;

  const seatSel = JSON.parse(localStorage.getItem("seatStyles") || "{}");

  const items = [];

  Object.values(seatSel).forEach(seat=>{
    items.push({
      handle: seat.handle,
      quantity: 1
    });
  });

  if(!items.length) return; // no addons

  e.preventDefault();

  fetch("/cart/add.js",{
    method:"POST",
    headers:{ "Content-Type":"application/json" },
    body:JSON.stringify({
      items: [
        {
          id: form.querySelector('[name="id"]').value,
          quantity: form.querySelector('[name="quantity"]').value
        },
        ...items
      ]
    })
  })
  .then(r=>r.json())
  .then(()=>{
    window.location.href="/cart";
  });

});
